import { render, staticRenderFns } from "./GlueRatingTableComponent.vue?vue&type=template&id=d80c11d2"
import script from "./GlueRatingTableComponent.vue?vue&type=script&lang=js"
export * from "./GlueRatingTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports